import { AxiosInstance } from 'axios';
import { type CartItem } from '../../../../types/isomorphic';
import apiUrl from '../apiUrl';

export class CartsService {
  #httpClient: AxiosInstance;
  baseUrl: string;

  constructor(httpClient: AxiosInstance) {
    this.#httpClient = httpClient;
    this.baseUrl = `${apiUrl}/carts`;
  }

  getAssetInCart = async (
    assetId: string
  ): Promise<CartItem | Record<string, never>> => {
    const url = `${this.baseUrl}/item`;
    try {
      const response = await this.#httpClient.get<CartItem>(url, {
        params: {
          assetId,
        },
      });
      return response.data;
    } catch (e) {
      return {};
    }
  };

  addAssetToCart = async (
    assetId: string,
    locationId?: string
  ): Promise<boolean> => {
    const url = `${this.baseUrl}/add-asset`;
    try {
      const response = await this.#httpClient.post(url, {
        assetId,
        locationId,
      });
      return response.status === 201;
    } catch (e) {
      return false;
    }
  };

  addPricedAssetToCart = async (
    assetId: string,
    license: string,
    sizeCode: string,
    usage: string | null = null,
    locationId: string | undefined = undefined
  ): Promise<boolean> => {
    const url = `${this.baseUrl}/add-priced-asset`;
    try {
      const response = await this.#httpClient.post(url, {
        assetId,
        sizeCode,
        license,
        usage,
        locationId,
      });
      return response.status === 201;
    } catch (e) {
      return false;
    }
  };

  addPricedModifiedAssetToCart = async (
    assetId: string,
    license: string,
    sizeCode: string,
    usage: string | null = null,
    genId: string | null = null,
    index: string | null = null,
    customMediaSizeCode: string | null = null,
    locationId: string | undefined = undefined
  ): Promise<boolean> => {
    const url = `${this.baseUrl}/add-priced-modified-asset`;
    try {
      const response = await this.#httpClient.post(url, {
        assetId,
        sizeCode,
        license,
        usage,
        genId,
        index,
        customMediaSizeCode,
        locationId,
      });
      return response.status === 201;
    } catch (e) {
      return false;
    }
  };

  removeAssetFromCart = async (assetId: string): Promise<boolean> => {
    const url = `${this.baseUrl}/remove-asset`;
    try {
      const response = await this.#httpClient.post(url, {
        assetId,
      });
      return response.status === 200;
    } catch (e) {
      return false;
    }
  };
}

export default CartsService;
